'use client'

import type { ChildrenProps } from '@snowball-tech/common/types'

import useLogger from '@snowball-tech/common/hooks/useLogger'
import { Button } from '@snowball-tech/fractal/dist/src/components/Button'

import { ComponentProps } from 'react'

import isEmpty from 'lodash/fp/isEmpty'

import useApi from '@/hooks/useApi'

type Props = {
  editionUuid: string
  href?: string
  label?: string
  sponsorBlockId?: string
  variant?: ComponentProps<typeof Button>['variant']
} & Partial<ChildrenProps>
export default function Component({
  children,
  editionUuid,
  href,
  label,
  sponsorBlockId,
  variant,
}: Props) {
  const endpoints = useApi()

  const logger = useLogger()

  const trackButtonClick = () => {
    if (isEmpty(href)) {
      return
    }

    // Fire and forget the analytics tracking call.
    endpoints.analytics.track.links
      .click(editionUuid, href, 'media', sponsorBlockId)
      .catch((trackingError) => {
        const error = trackingError as Error

        logger.warn(
          `[EDITION] An error occurred when tracking the click on the button linking to "${href}" for "${editionUuid}": "${error.message}"`,
          { editionUuid, href, label, sponsorBlockId },
          error,
        )
      })
  }

  return (
    <Button
      className="max-h-fit [&_span]:max-w-full [&_span]:whitespace-break-spaces"
      href={href}
      label={label}
      target="_blank"
      variant={variant}
      onClick={isEmpty(href) ? undefined : trackButtonClick}
    >
      {children}
    </Button>
  )
}
